import React, { Component } from "react";
import _ from 'i18n';
import { Spin, Icon } from 'antd';


export default class EventCardFeetching extends Component {

  render() {
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

    const { appType } = this.props;
    return (
      <div className={'event-stats-app-type-card fetching text-center'}>
        <div className={'card-app-type-title'}>
          {appType == 'global' ? _('GLOBAL') :
            (appType == 'registering' ? _('registering') + 's' :
              (appType == 'cycle_registering' ? _('cycle_registering') + 's' :
                (appType == 'all_in' ? _('SEASONS') :
                  (appType == 'premium' ? 'Premium' : (appType == 'cycle_essential' ? "Cycle Essentiel" :  _('CONGRESS'))))))}
        </div>
        <div className={'flex justify-center'}>
          <Spin indicator={antIcon} />
        </div>
      </div>
    );
  }
}







// WEBPACK FOOTER //
// ./app/components/feetching/EventCardFeetching.js